import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptDecryptService {
  private key = CryptoJS.enc.Utf8.parse('environment.apiEncryptKey');
  private iv = CryptoJS.enc.Utf8.parse('environment.apiEncryptIV');
  constructor() {}

  encrypt(plainText: string): string {
    var encrypted: any = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted;
  }
}
